<div class="page-container">
  <div class="page-header">
    <div>
      <h1 class="gradient-text">Сесії паркування</h1>
      <p class="subtitle">Моніторинг активних та завершених сесій</p>
    </div>
  </div>

  <mat-card>
    <mat-tab-group (selectedIndexChange)="onTabChange($event)">
      <mat-tab label="Активні сесії">
        <div class="tab-content">
          @if (loading) {
            <div class="loading-container">
              <mat-spinner></mat-spinner>
            </div>
          } @else {
            <table mat-table [dataSource]="activeSessions" class="sessions-table">
              <ng-container matColumnDef="mallId">
                <th mat-header-cell *matHeaderCellDef>Паркінг</th>
                <td mat-cell *matCellDef="let session">
                  <div class="mall-info">
                    <mat-icon>local_parking</mat-icon>
                    <span>{{session.mallName || session.mallId}}</span>
                  </div>
                </td>
              </ng-container>

              <ng-container matColumnDef="carId">
                <th mat-header-cell *matHeaderCellDef>Номер авто</th>
                <td mat-cell *matCellDef="let session">
                  <div class="car-info">
                    <mat-icon>directions_car</mat-icon>
                    <strong>{{session.carNumber || session.carId}}</strong>
                  </div>
                </td>
              </ng-container>

              <ng-container matColumnDef="startTime">
                <th mat-header-cell *matHeaderCellDef>Час початку</th>
                <td mat-cell *matCellDef="let session">
                  {{session.startTime | date:'dd.MM.yyyy HH:mm'}}
                </td>
              </ng-container>

              <ng-container matColumnDef="duration">
                <th mat-header-cell *matHeaderCellDef>Тривалість</th>
                <td mat-cell *matCellDef="let session">
                  <span class="duration">{{getDuration(session)}}</span>
                </td>
              </ng-container>

              <ng-container matColumnDef="paymentType">
                <th mat-header-cell *matHeaderCellDef>Тип оплати</th>
                <td mat-cell *matCellDef="let session">
                  @if (session.paymentType === 'subscription') {
                    <mat-chip class="type-subscription">
                      <mat-icon>credit_card</mat-icon>
                      {{session.subscriptionName || 'Абонемент'}}
                    </mat-chip>
                  } @else {
                    <mat-chip class="type-hourly">
                      <mat-icon>schedule</mat-icon>
                      Погодинна
                    </mat-chip>
                  }
                </td>
              </ng-container>

              <ng-container matColumnDef="cost">
                <th mat-header-cell *matHeaderCellDef>Вартість</th>
                <td mat-cell *matCellDef="let session">
                  <span class="cost">{{session.cost || 0}} ₴</span>
                </td>
              </ng-container>

              <ng-container matColumnDef="status">
                <th mat-header-cell *matHeaderCellDef>Статус</th>
                <td mat-cell *matCellDef="let session">
                  <mat-chip class="status-active">Активна</mat-chip>
                </td>
              </ng-container>

              <ng-container matColumnDef="actions">
                <th mat-header-cell *matHeaderCellDef>Дії</th>
                <td mat-cell *matCellDef="let session">
                  <button mat-raised-button color="warn" (click)="stopSession(session)">
                    <mat-icon>stop</mat-icon>
                    Завершити
                  </button>
                </td>
              </ng-container>

              <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
              <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
            </table>

            @if (activeSessions && activeSessions.length === 0) {
              <div class="empty-state">
                <mat-icon>local_parking</mat-icon>
                <h3>Немає активних сесій</h3>
                <p>Активні сесії паркування відображатимуться тут</p>
              </div>
            }
          }
        </div>
      </mat-tab>

      <mat-tab label="Історія">
        <div class="tab-content">
          @if (loading) {
            <div class="loading-container">
              <mat-spinner></mat-spinner>
            </div>
          } @else {
            <table mat-table [dataSource]="sessionHistory" class="sessions-table">
              <ng-container matColumnDef="mallId">
                <th mat-header-cell *matHeaderCellDef>Паркінг</th>
                <td mat-cell *matCellDef="let session">
                  <div class="mall-info">
                    <mat-icon>local_parking</mat-icon>
                    <span>{{session.mallName || session.mallId}}</span>
                  </div>
                </td>
              </ng-container>

              <ng-container matColumnDef="carId">
                <th mat-header-cell *matHeaderCellDef>Номер авто</th>
                <td mat-cell *matCellDef="let session">
                  <div class="car-info">
                    <mat-icon>directions_car</mat-icon>
                    <strong>{{session.carNumber || session.carId}}</strong>
                  </div>
                </td>
              </ng-container>

              <ng-container matColumnDef="startTime">
                <th mat-header-cell *matHeaderCellDef>Час</th>
                <td mat-cell *matCellDef="let session">
                  {{session.startTime | date:'dd.MM.yyyy HH:mm'}}
                </td>
              </ng-container>

              <ng-container matColumnDef="duration">
                <th mat-header-cell *matHeaderCellDef>Тривалість</th>
                <td mat-cell *matCellDef="let session">
                  <span class="duration">{{getDuration(session)}}</span>
                </td>
              </ng-container>

              <ng-container matColumnDef="paymentType">
                <th mat-header-cell *matHeaderCellDef>Тип оплати</th>
                <td mat-cell *matCellDef="let session">
                  @if (session.paymentType === 'subscription') {
                    <mat-chip class="type-subscription">
                      <mat-icon>credit_card</mat-icon>
                      {{session.subscriptionName || 'Абонемент'}}
                    </mat-chip>
                  } @else {
                    <mat-chip class="type-hourly">
                      <mat-icon>schedule</mat-icon>
                      Погодинна
                    </mat-chip>
                  }
                </td>
              </ng-container>

              <ng-container matColumnDef="cost">
                <th mat-header-cell *matHeaderCellDef>Вартість</th>
                <td mat-cell *matCellDef="let session">
                  <span class="cost">{{session.cost || 0}} ₴</span>
                </td>
              </ng-container>

              <ng-container matColumnDef="status">
                <th mat-header-cell *matHeaderCellDef>Статус</th>
                <td mat-cell *matCellDef="let session">
                  <mat-chip [class]="'status-' + session.status">
                    {{session.status === 'completed' ? 'Завершена' : session.status === 'cancelled' ? 'Скасована' : session.status}}
                  </mat-chip>
                </td>
              </ng-container>

              <ng-container matColumnDef="actions">
                <th mat-header-cell *matHeaderCellDef>Дії</th>
                <td mat-cell *matCellDef="let session">
                  <button mat-icon-button>
                    <mat-icon>visibility</mat-icon>
                  </button>
                </td>
              </ng-container>

              <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
              <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
            </table>

            @if (sessionHistory && sessionHistory.length === 0) {
              <div class="empty-state">
                <mat-icon>history</mat-icon>
                <h3>Історія порожня</h3>
                <p>Завершені сесії відображатимуться тут</p>
              </div>
            }
          }
        </div>
      </mat-tab>
    </mat-tab-group>
  </mat-card>
</div>
